import { useTranslation } from '@/hooks/useTranslation';
import { Brain, Cpu, Code, Eye, Zap, Lightbulb, ArrowRight, type LucideIcon } from 'lucide-react';
import { useReveal } from '@/hooks/useReveal';
import { Link } from 'react-router-dom';
import { SERVICE_SLUGS } from '@/pages/services/serviceData';

const iconMap: Record<string, LucideIcon> = {
  brain: Brain, cpu: Cpu, code: Code, eye: Eye, zap: Zap, lightbulb: Lightbulb,
};

const ServicesSection = () => {
  const { t } = useTranslation();
  useReveal();

  return (
    <section id="services">
      <div className="services-header rev">
        <div>
          <div className="section-tag">{t.services.tag}</div>
          <h2 className="section-h" style={{ whiteSpace: 'pre-line' }}>{t.services.title}</h2>
        </div>
        <p className="section-sub">{t.services.subtitle}</p>
      </div>

      <div className="services-grid">
        {t.services.items.map((svc, i) => {
          const Icon = iconMap[svc.icon] || Brain;
          return (
            <div className="svc" key={i}>
              <div className="svc-num">{svc.num}</div>
              <div className="svc-icon"><Icon size={22} /></div>
              <h3 className="svc-h">{svc.title}</h3>
              <p className="svc-p">{svc.description}</p>
              <div className="svc-tags">
                {svc.tags.map((tag, j) => (
                  <span className="tag" key={j}>{tag}</span>
                ))}
              </div>
              <Link to={`/services/${SERVICE_SLUGS[i]}`} className="inline-flex items-center gap-1.5 mt-4 text-sm font-semibold transition-colors hover:text-[var(--amber)]" style={{ color: 'var(--blue)', fontFamily: 'var(--f-body)' }}>
                Learn more <ArrowRight size={14} />
              </Link>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default ServicesSection;
